var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEllipseUpArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ep:arrow-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.2751 10.0249L6.30887 3.05552C6.19263 2.93917 6.03821 2.87427 5.87762 2.87427C5.71703 2.87427 5.5626 2.93917 5.44637 3.05552L5.43887 3.06339C5.38232 3.1198 5.3373 3.18769 5.30653 3.26294C5.27577 3.33819 5.2599 3.41922 5.2599 3.50111C5.2599 3.583 5.27577 3.66404 5.30653 3.73929C5.3373 3.81454 5.38232 3.88243 5.43887 3.93883L11.9989 10.5013L5.43887 17.0612C5.38232 17.1176 5.3373 17.1855 5.30653 17.2607C5.27577 17.336 5.2599 17.417 5.2599 17.4989C5.2599 17.5808 5.27577 17.6618 5.30653 17.7371C5.3373 17.8123 5.38232 17.8802 5.43887 17.9366L5.44637 17.9445C5.5626 18.0609 5.71703 18.1258 5.87762 18.1258C6.03821 18.1258 6.19263 18.0609 6.30887 17.9445L13.2751 10.9751C13.3364 10.9139 13.3852 10.8401 13.4185 10.7585C13.4518 10.6768 13.469 10.5889 13.469 10.5C13.469 10.4112 13.4518 10.3232 13.4185 10.2416C13.3852 10.1599 13.3364 10.0862 13.2751 10.0249Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseUpArrow);
export default __webpack_public_path__ + "static/media/ellipse-up-arrow.6bdb6493b94c85357c889eda2eb7b054.svg";
export { ForwardRef as ReactComponent };